import '../../../../assets/css/screens/serviceprovider/dashboard/bidjobs/BidJobs.css';
import WorkerNavbar from '../../../../components/serviceprovider/workerdashboard/Workernavbar/WorkerNavbar';
import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import AppContext from '../../../../context/AppContext';
import {
  ArrowLeft, CheckCheck
} from 'lucide-react';

import { statusLabels, TABS } from '../../../../components/serviceprovider/workerdashboard/workerbidjobs/bidjobsconstants/BidJobsConstants';
import DisputeModal from '../../../../components/serviceprovider/workerdashboard/workerbidjobs/disputemodal/DisputeModal';
import ReviewModal from '../../../../components/serviceprovider/workerdashboard/workerbidjobs/reviewmodal/ReviewModal';
import BidModal from '../../../../components/serviceprovider/workerdashboard/workerbidjobs/bidmodal/BidModal';
import ProofModal from '../../../../components/serviceprovider/workerdashboard/workerbidjobs/proofmodal/ProofModal';
import Lightbox from '../../../../components/serviceprovider/workerdashboard/workerbidjobs/lightbox/LightBox';
import BidJobCard from '../../../../components/serviceprovider/workerdashboard/workerbidjobs/bidjobcard/BidJobCard';

/* ══════════ MAIN ══════════ */
const BidJobs = () => {
  const navigate = useNavigate();
  const { baseUrl, baseUrlForFile } = useContext(AppContext);
  const [activeTab, setActive] = useState('All');
  const [proofFor, setProofFor] = useState(null);
  const [lightbox, setLightbox] = useState(null);
  const [replies, setReplies] = useState({});
  const [disputeFor, setDisputeFor] = useState(null);
  const [disputeLoading, setDisputeLoading] = useState(false);
  const [reviews, setReviews] = useState({});
  const [reviewFor, setReviewFor] = useState(null);
  const [jobReviews, setJobReviews] = useState({});
  const [bidModalFor, setBidModalFor] = useState(null);
const currentWorkerId = JSON.parse(
  atob(localStorage.getItem("authToken").split('.')[1])
).sub;

console.log("CURRENT WORKER ID:", currentWorkerId);
// console.log("WORKER DATA", workerData);
console.log("CURRENT ID", currentWorkerId);

  const [bids, setBids] = useState([]);

  // view all jobs
 const viewallavailablejobs = () => {
  const authToken = localStorage.getItem("authToken");

  axios.get(`${baseUrl}/worker/viewalljobs`, {
    params:{
      status: activeTab === 'All' ? '' : activeTab
    },
    headers:{
      Authorization:`Bearer ${authToken}`
    }
  })
.then(res=>{

  console.log("FULL JOB DATA", res.data.postjobs);
  

  res.data.postjobs.forEach(job=>{
    console.log(
      "ID:", job.id,
      "BIDDING:", job.bidding,
      "SERVICE PROVIDER:", job.whserviceprovider_id,
      "STATUS:", job.status
    );
  });

setBids(res.data.postjobs || []);

res.data.postjobs.forEach(job => {
  fetchReview(job.id);
});

})
  .catch(err=>console.log(err));

};

  useEffect(() => {
    viewallavailablejobs();
  }, [activeTab]);

  //  accept  no biddinh jobs
  const handleAcceptJob = (jobId)=>{
const authToken = localStorage.getItem("authToken");
axios.post(`${baseUrl}/worker/acceptjob`,
{
 job_id: jobId
},
{
 headers: {
        Authorization: `Bearer ${authToken}`
      }
}
)
.then(res=>{

console.log(res.data);

// jobs refresh
viewallavailablejobs();

})
.catch(err => {

 if(err.response?.status === 409){

   alert("Job already assigned");

   viewallavailablejobs();

 }

})

}
  // rating and review
  const setReviewField = (id, key, val) =>
    setReviews(prev => ({ ...prev, [id]: { ...(prev[id] || {}), [key]: val } }));

  const handleReview = (jobId) => {
    const authToken = localStorage.getItem('authToken');
    const r = reviews[jobId] || {};
    const job = bids.find(b => b.id === jobId);

    const formData = new FormData();
    formData.append('whpostjob_id', jobId);
    formData.append('workerrating', r.rating);
    formData.append('workerreview', r.text);
    formData.append('whcustomer_id', job?.whcustomer?.id || '');
    formData.append('whserviceprovider_id', job?.whserviceprovider_id || '');

    axios.post(`${baseUrl}/worker/jobreview`, formData, {
      headers: {
        Authorization: `Bearer ${authToken}`,
        'Content-Type': 'multipart/form-data',
      },
    })
      .then(res => {
        console.log(job);
        console.log(job?.whcustomer);
        console.log(job?.whserviceprovider);
        console.log('Review submitted:', res.data);
      setJobReviews(prev => ({
  ...prev,
  [jobId]: {
    worker: {
      rating: r.rating,
      review: r.text
    }
  }
}));
        setReviews(prev => ({ ...prev, [jobId]: {} }));
        viewallavailablejobs();
      })
      .catch(err => console.log(err.response?.data || err.message));
  };

  // fetch reviews
 const fetchReview = (jobId) => {

  const authToken = localStorage.getItem('authToken');

  axios.get(`${baseUrl}/worker/viewreview/${jobId}`, {
    headers: {
      Authorization: `Bearer ${authToken}`
    }
  })
  .then(res => {


    const workerReview = res.data.worker_review;
    const customerReview = res.data.customer_review;


    setJobReviews(prev => ({
      ...prev,
      [jobId]: {


        // pehle worker check hoga
        worker: {
          rating: workerReview?.workerrating,
          review: workerReview?.workerreview,
        },


        // sirf tab customer show hoga jab worker review kare
        customer: workerReview ? {

          rating: customerReview?.customerrating,
          review: customerReview?.customerreview,

        } : null


      }
    }));

  })

  .catch(err =>
    console.log(err.message)
  );

};

  // create ticket
  const handleRaiseDispute = ({ category, description }) => {
    const authToken = localStorage.getItem("authToken");
    setDisputeLoading(true);

    const formData = new FormData();

    formData.append("whpostjob_id", disputeFor.id);
    formData.append("customer_id", disputeFor.whcustomer_id);

    formData.append("category", category);
    formData.append("description", description);
    formData.append("raisedby", "worker");
    formData.append("against", "customer");

    axios.post(`${baseUrl}/worker/helpsupport`, formData, {
      headers: {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "multipart/form-data",
      },
    })
      .then((res) => {
        console.log("Dispute Ticket Created:", res.data);

        setDisputeFor(null);

        // refresh jobs → status update (if backend does it)
        viewallavailablejobs();
      })
      .catch((err) => {
        console.log(err.response?.data || err.message);
      })
      .finally(() => {
        setDisputeLoading(false);
      });
  };

  // conversation create
  const createConversation = (job) => {

    const authToken = localStorage.getItem('authToken');

    return axios.post(
      `${baseUrl}/customer/createconversation`,
      {
        job_id: job.id,
        message: job.description
      },
      {
        headers: { Authorization: `Bearer ${authToken}` }
      }
    );
  };

  // start job
  const handleStart = (id) => {
    const authToken = localStorage.getItem("authToken");

    axios.post(`${baseUrl}/worker/startjob`,
      { id },
      {
        headers: {
          Authorization: `Bearer ${authToken}`
        }
      }
    )
      .then((res) => {
        console.log("START JOB RESPONSE:", res.data);

        viewallavailablejobs();

      })
      .catch(err => {
        console.log(err.response?.data || err.message);
      });
  };

  const refresh = () => {
    viewallavailablejobs();
  };

  // cancel jobs
  const handleCancel = (id) => {
    const authToken = localStorage.getItem("authToken");

    axios.post(`${baseUrl}/worker/canceljob`,
      { job_id: id },
      {
        headers: {
          Authorization: `Bearer ${authToken}`
        }
      }
    )
      .then((res) => {
        console.log(res.data);
        viewallavailablejobs();
      })
      .catch(err => {
        console.log(err.response?.data || err.message);
      });
  };

  /* ── Open dispute ticket chat ── */
  const openDisputeChat = async (job) => {
    const authToken = localStorage.getItem('authToken');
    console.log(job);
    navigate(`/worker-chat/${job.whconversation?.id}`, {
      state: { description: job.description }
    });
  };

  // worker jobproof
  const handleProof = (files) => {
    const authToken = localStorage.getItem("authToken");

    const formData = new FormData();

    files.forEach(fileObj => {
      formData.append("media[]", fileObj.file);
    });

    formData.append("whpostjob_id", proofFor);

    axios.post(`${baseUrl}/worker/jobproof`, formData, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
        "Content-Type": "multipart/form-data"
      }
    })
      .then(res => {
        console.log(res.data);

        setProofFor(null);

        viewallavailablejobs();
      })
      .catch(err => {
        console.log(err.response?.data || err.message);
      });
  };

  const handleReply = (id) => {

  };
const filteredJobs = bids.filter(job => {
  const status = (job.display_status || job.status || '')
    .toString()
    .trim()
    .toLowerCase();

  switch (activeTab.toLowerCase()) {
    case 'all':
      return true;

    case 'pending':
      return status === 'pending';

    case 'bid_sent':
      return status === 'bid_sent';

    case 'assigned':
      return status === 'assigned';

    case 'in_progress':
      return status === 'in_progress';

    case 'awaiting_confirmation':
      return status === 'awaiting_confirmation';

    case 'completed':
      return status === 'completed';

    case 'rejected':
      return status === 'rejected';

    case 'cancelled':
      return status === 'cancelled';

    case 'raise_dispute':
      return status === 'raise_dispute';

    default:
      return true;
  }
});
  const handleBidSubmit = (jobId, bidAmount, message, onDone) => {
    const authToken = localStorage.getItem("authToken");
    const formData  = new FormData();
    formData.append("message",      message);
    formData.append("bidAmount",    bidAmount);
    formData.append("whpostjob_id", jobId);

    axios.post(`${baseUrl}/worker/placebid`, formData, {
      headers: {
        Authorization: `Bearer ${authToken}`,
        "Content-Type": "multipart/form-data",
      },
    })
      .then(res => {
        console.log(res.data);
        onDone?.();
        viewallavailablejobs();
      })
      .catch(err => {
        console.log(err.response?.data || err.message);
        onDone?.();
      });
  };



  // token ka life time zayada kiyaa
useEffect(() => {
  viewallavailablejobs();
}, [activeTab]);

useEffect(() => {
  const interval = setInterval(() => {
    viewallavailablejobs();
  }, 10000);

  return () => clearInterval(interval);
}, []);



  return (
    <>
      <WorkerNavbar />
      <div className="aj-page">

        <div className="aj-header">
          <button className="aj-back-btn" onClick={() => navigate(-1)}><ArrowLeft size={22} /></button>
          <h2 className="aj-title">Bid Jobs</h2>
        </div>

        <div className="aj-tabs">
          {TABS.map(t => {
           const count =
t === 'All'
? bids.length
: bids.filter(
 b => (b.display_status || b.status || '').toLowerCase() === t.toLowerCase()
).length;

            return (
              <button
                key={t}
                className={'aj-tab' + (activeTab === t ? ' aj-tab--active' : '')}
                onClick={() => setActive(t)}
              >
                {t === 'All' ? 'All' : (statusLabels[t] || t)}
                <span className="aj-tab__count">
                  {count}
                </span>
              </button>
            );
          })}
        </div>

        <div className="aj-list">
          {bids.length === 0 ? (
            <div className="aj-empty"><CheckCheck size={42} /><p>No bids in this state</p></div>
          ) : filteredJobs.map((b, i) => {
            console.log("JOB STATUS => ", b.status);
            return (
              <BidJobCard
                key={b.id}
                b={b}
                i={i}
                jobReviews={jobReviews}
                reviews={reviews}
                replies={replies}
                setReplies={setReplies}
                setLightbox={setLightbox}
                setProofFor={setProofFor}
                setDisputeFor={setDisputeFor}
                setReviewFor={setReviewFor}
                setBidModalFor={setBidModalFor}
                handleStart={handleStart}
                handleCancel={handleCancel}
                handleBidSubmit={handleBidSubmit}
                handleReply={handleReply}
                viewallavailablejobs={viewallavailablejobs}
                handleAcceptJob={handleAcceptJob}
                 currentWorkerId={currentWorkerId}

              />
            );
          })}
        </div>
      </div>

      {bidModalFor && (
        <BidModal
          jobId={bidModalFor}
          onClose={() => setBidModalFor(null)}
          onSubmit={handleBidSubmit}
        />
      )}

      {proofFor &&
        <ProofModal
          onClose={() => setProofFor(null)}
          onSubmit={(files) => {
            handleProof(files);
          }}
        />}

      {reviewFor && (
        <ReviewModal
          onClose={() => setReviewFor(null)}
          jobId={reviewFor}
          reviewData={reviews[reviewFor]}
          onReviewChange={setReviewField}
          onSubmit={(jobId) => {
            handleReview(jobId);
            setReviewFor(null);
          }}
        />
      )}

      {disputeFor && (
        <DisputeModal
          onClose={() => setDisputeFor(null)}
          onSubmit={handleRaiseDispute}
          loading={disputeLoading}
        />
      )}

      <Lightbox item={lightbox} onClose={() => setLightbox(null)} />
    </>
  );
};

export default BidJobs;